export enum ReturnStatus {
  FirstTimeEntry = 0,
  Complete = 1,
  OverQuota = 2,
  Terminate = 3,
  SecurityTerminate = 4,
  SCSecurityTerminate = 6,
  SCTerminate = 8,
  PartialComplete = 13,
  ClientDropRediirect = 11
}
